import React from 'react';
import StatusCard from './StatusCard';
import Carousel from "../../../components/Carousel";
import {useQuery} from "@tanstack/react-query";
import {FEATURE_STATUS_KEY, fetchHomeStatus} from "../../../../api/public-voissa/features";

const Status = (props) => {
    let {status = [], start = 0} = props;
    let end = start + 3;
    for (let i = 0; i <= 3; i++) {
        let sliced = status.slice(start, end);
        start = start + 4;
        end = start + 3;
        return (
            <div className="col">
                <div className="status-wrapper">
                    {sliced.map((status) => (
                        <StatusCard
                            key={status._id}
                            {...status}
                        />
                    ))}
                </div>
            </div>
        )
    }
}

function fnclearDraft(contentRaw = {}){
    let isContent = false;
    contentRaw.blocks = contentRaw.blocks.map((item)=>{
        item.text = item.text.replace(/(?:https?|ftp):\/\/[\n\S]+/g, '');
        if(item.text !== "attachment" && item.text !== "📷" && item.text !== ""){
            isContent = true;
        }
        item.text = item.text.trim();
        return item;
    });

    return {contentRaw, isContent};
}

function clearStatus(statusList){
    let status = Array.isArray(statusList) ? statusList : [];
    let newStatus = [];
    status.forEach(item=>{
        let clearDraft = fnclearDraft(item.contentRaw);
        if(clearDraft.isContent){
            item.contentRaw = clearDraft.contentRaw;
            newStatus.push(item);
        }
    });
    return newStatus.slice(0,96);
}

const StatusHome = () =>{
    const {isSuccess : isSuccessStatus, data : dataStatus} = useQuery(
        [FEATURE_STATUS_KEY],
        ()=> fetchHomeStatus(),
        {
            staleTime : (1000 * 60 * 5),
            placeholderData : {
                data : [],
            },
            select : (data) =>{
                let status = data.data || [];
                return clearStatus(status);
            }
        }
    );

    return isSuccessStatus ? (
        <div className="container">
            <div className="col left">
                <div className="head-title">
                    <div className="section-title">Les derniers statuts</div>
                </div>
                <Carousel>
                    <div className="pane">
                        <div className="row">
                            <div className="left-col-wrapper">
                                <Status status={dataStatus} start={0} />
                                <Status status={dataStatus} start={4} />
                                <Status status={dataStatus} start={8} />
                            </div>
                        </div>
                    </div>
                    {dataStatus.length > 12 ? (
                        <div className="pane">
                            <div className="row">
                                <div className="left-col-wrapper">
                                    <Status status={dataStatus} start={12} />
                                    <Status status={dataStatus} start={16} />
                                    <Status status={dataStatus} start={20} />
                                </div>
                            </div>
                        </div>
                    ) : null}
                    {dataStatus.length > 24 ? (
                        <div className="pane">
                            <div className="row">
                                <div className="left-col-wrapper">
                                    <Status status={dataStatus} start={24} />
                                    <Status status={dataStatus} start={28} />
                                    <Status status={dataStatus} start={30} />
                                </div>
                            </div>
                        </div>
                    ) : null}
                    {dataStatus.length > 34 ? (
                        <div className="pane">
                            <div className="row">
                                <div className="left-col-wrapper">
                                    <Status status={dataStatus} start={34} />
                                    <Status status={dataStatus} start={38} />
                                    <Status status={dataStatus} start={42} />
                                </div>
                            </div>
                        </div>
                    ) : null}
                    {dataStatus.length > 46 ? (
                        <div className="pane">
                            <div className="row">
                                <div className="left-col-wrapper">
                                    <Status status={dataStatus} start={46} />
                                    <Status status={dataStatus} start={50} />
                                    <Status status={dataStatus} start={54} />
                                </div>
                            </div>
                        </div>
                    ) : null}
                    {dataStatus.length > 58 ? (
                        <div className="pane">
                            <div className="row">
                                <div className="left-col-wrapper">
                                    <Status status={dataStatus} start={58} />
                                    <Status status={dataStatus} start={62} />
                                    <Status status={dataStatus} start={66} />
                                </div>
                            </div>
                        </div>
                    ) : null}
                    {dataStatus.length > 70 ? (
                        <div className="pane">
                            <div className="row">
                                <div className="left-col-wrapper">
                                    <Status status={dataStatus} start={70} />
                                    <Status status={dataStatus} start={74} />
                                    <Status status={dataStatus} start={78} />
                                </div>
                            </div>
                        </div>
                    ) : null}
                    {dataStatus.length > 82 ? (
                        <div className="pane">
                            <div className="row">
                                <div className="left-col-wrapper">
                                    <Status status={dataStatus} start={82} />
                                    <Status status={dataStatus} start={86} />
                                    <Status status={dataStatus} start={90} />
                                </div>
                            </div>
                        </div>
                    ) : null}
                </Carousel>
            </div>
        </div>
    ) : null
};

export default StatusHome;